<template>
  <v-list-item
    class="list-item"
    data-testid="routine-list-item"
    :key="routine.id"
    @click="$emit('click', routine)"
  >
    <v-list-item-action class="ma-0 mr-2">
      <v-checkbox
        :input-value="selected"
        @change="$emit('click', routine)"
        @click.native.stop
        hide-details
        class="mt-0"
      />
    </v-list-item-action>

    <v-list-item-content class="pt-1 pb-1">
      <div class="d-flex align-center justify-space-between overflow-hidden">
        <div class="flex-grow-0 flex-shrink-1 overflow-hidden">
          <v-list-item-title class="font-size-13 name">
            <text-highlight
              highlightClass="yellow lighten-1"
              data-private
              highlightComponent="span"
              :queries="highlights"
              :title="routineName"
            >
              {{ routineName }}
            </text-highlight>
          </v-list-item-title>

          <p class="ma-0 font-size-10 blue-grey--text position">
            {{ routineType }}
          </p>
        </div>
      </div>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: 'RoutineListItem',

  props: {
    routine: Object,
    searchTerm: {
      type: String,
      default: '',
    },
    selected: Boolean,
  },

  computed: {
    routineName() {
      return this.routine?.name || this.$t('routines.unnamed_routine')
    },

    routineType() {
      return this.routine.type
        ? this.$t(`routines.type.${this.routine.type}`)
        : ''
    },
    defaultHighlightQueries() {
      return [this.searchTerm ?? '', ...(this.searchTerm?.split?.(' ') ?? [])]
    },
    highlights() {
      return this.routine?.highlights?.name || this.defaultHighlightQueries
    },
  },
}
</script>

<style scoped lang="scss">
.name {
  line-height: 20px !important;
}

.position {
  line-height: 16px !important;
}

.list-item.v-list-item::before,
.list-item.v-list-item:hover {
  border-radius: 4px !important;
  background-color: $color-blue-grey-lighten3;
}

.v-list-item__action {
  margin-top: 0;
  margin-bottom: 0;
  min-width: 40px;
}
</style>
